'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var moment = _interopDefault(require('moment'));

var momentToDateYear = function (date) {
    return [date.format('M'), date.format('YYYY')];
};
var getDefaultEndDateYear = function () {
    return momentToDateYear(moment());
};
var getMonthYear = function (value, currentMonth, currentYear) {
    if (value === 12 || value === 24) {
        return {
            month: currentMonth + 1,
            year: parseInt(currentYear, 10) - value / 12,
        };
    }
    if (value > currentMonth) {
        return {
            month: currentMonth + 12 - value + 1,
            year: parseInt(currentYear, 10) - 1,
        };
    }
    return {
        month: currentMonth - value + 1,
        year: parseInt(currentYear, 10),
    };
};
var getStartMonthYear = function (value, currentMonth, currentYear) {
    var values = getMonthYear(value, currentMonth, currentYear);
    var month = values.month, year = values.year;
    while (month > 12) {
        month -= 12;
        year += 1;
    }
    return { month: "" + month, year: "" + year };
};
var buildPossibleYears = function (year) {
    var results = [];
    var current = parseInt(year, 10);
    while (current > 2009) {
        results.push(current.toString());
        current -= 1;
    }
    return results;
};
var getStartValues = function (value) {
    var _a = getDefaultEndDateYear(), currentMonth = _a[0], currentYear = _a[1];
    var intValue;
    switch (value) {
        case '3':
        case '6':
        case '12':
        case '24':
            intValue = parseInt(value, 10);
            break;
        case 'custom':
        default:
            intValue = 12;
            break;
    }
    var _b = getStartMonthYear(intValue, parseInt(currentMonth, 10), currentYear), month = _b.month, year = _b.year;
    return {
        month: month,
        year: year,
    };
};

exports.buildPossibleYears = buildPossibleYears;
exports.getDefaultEndDateYear = getDefaultEndDateYear;
exports.getStartMonthYear = getStartMonthYear;
exports.getStartValues = getStartValues;
